import { Injectable, Injector } from '@angular/core';
import { TranslateService, TranslateStore, TranslateLoader, TranslateCompiler, TranslateParser, MissingTranslationHandler } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExtendedTranslateService extends TranslateService {


  constructor(
    store: TranslateStore,
    loader: TranslateLoader,
    compiler: TranslateCompiler,
    parser: TranslateParser,
    missingTranslationHandler: MissingTranslationHandler
  ) {
    super(
        store,
        loader,
        compiler,
        parser,
        missingTranslationHandler,
        true,
        false,
        false,
        'en-US'
    );
  }

  override instant(key: string | string[], interpolateParams?: Object): string | any {
    const upperKey = typeof key === 'string' ? key.toUpperCase() : key.map(k => k.toUpperCase());
    return super.instant(upperKey, interpolateParams);
  }

  override get(key: string | string[], interpolateParams?: Object): Observable<string | any> {
    const upperKey = typeof key === 'string' ? key.toUpperCase() : key.map(k => k.toUpperCase());
    return super.get(upperKey, interpolateParams);
  }
}
